import { render, staticRenderFns } from "./ShopifyExtensionBanner.vue?vue&type=template&id=7b5d1466&scoped=true&"
import script from "./ShopifyExtensionBanner.vue?vue&type=script&lang=ts&"
export * from "./ShopifyExtensionBanner.vue?vue&type=script&lang=ts&"
import style0 from "./ShopifyExtensionBanner.vue?vue&type=style&index=0&id=7b5d1466&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5d1466",
  null
  
)

export default component.exports